import { getErrorStatusCode } from '#layers/base/public';

/**
 * A 404 on an auth-providers endpoint means the feature is not configured for
 * this org, so the UI shows an empty state rather than an error.
 */
export function isMissingEndpointError(error: unknown): boolean {
	return getErrorStatusCode(error) === 404;
}
